import { graphql, useMutation } from "react-relay";
import { useCreateConnectInboxMutation } from "./__generated__/useCreateConnectInboxMutation.graphql";

export function useCreateConnectInbox() {
  return useMutation<useCreateConnectInboxMutation>(graphql`
    mutation useCreateConnectInboxMutation($input: CreateConnectInboxInput!) {
      store {
        createConnectInbox(input: $input) {
          connectInbox {
            id
          }
        }
      }
    }
  `);
}
